module.exports = __webpack_public_path__ + "9b79e57612150649b925e7f768b71076.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-5.jpg
// module id = 1178
// module chunks = 0